export default __webpack_public_path__ + "static/bridge_green-d11e732d3c5bbdcd3142bec1200d459f.png";